import Restful from '../utils/restful.js'
import http from '../utils/http.js'
const project = 'sci/'

const macademic = new Restful(project, 'macademic')

macademic.manuscript = (id, type, sign) => {
  const url = project + `macademic/manuscript/${id}/${type}`
  return http.get(url, { sign }).then(res => {
    return res
  })
}

macademic.authorReply = data => {
  const url = project + `macademic/manuscript/editor/author_reply`
  return http.put(url, data).then(res => {
    return res
  })
}

macademic.person = data => {
  const url = project + `macademic/person`
  return http.get(url, data).then(res => {
    return res
  })
}

macademic.personRecord = (id, data) => {
  const url = project + `macademic/person/${id}`
  return http.get(url, data).then(res => {
    return res
  })
}

macademic.started = (id, type, data) => {
  const url = project + `macademic/started/${id}/${type}`
  return http.put(url, data).then(res => {
    return res
  })
}

macademic.invite = (id, type, data) => {
  const url = project + `macademic/invite/${id}/${type}`
  return http.post(url, data).then(res => {
    return res
  })
}

macademic.cancelInvite = (id, type, data) => {
  const url = project + `macademic/invite/cancel/${id}/${type}`
  return http.put(url, data).then(res => {
    return res
  })
}

macademic.mfile = data => {
  const url = project + `macademic/mfile`
  return http.post(url, [data]).then(res => {
    return res
  })
}

macademic.mfileDel = id => {
  const url = project + `macademic/mfile/${id}`
  return http.del(url).then(res => {
    return res
  })
}
// 查看外编决策
macademic.meditor = (id, type, data) => {
  const url = project + `macademic/meditor/${id}/${type}`
  return http.get(url, data).then(res => {
    return res
  })
}
macademic.commitDecision = (id, type, data) => {
  const url = project + `macademic/meditor/${id}/${type}`
  return http.put(url, data).then(res => {
    return res
  })
}

// 提醒外编邮件
macademic.remind = (id, data) => {
  const url = project + `macademic/remind/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}

// 感谢信状态
macademic.acked = (id, data) => {
  const url = project + `macademic/acked/${id}`
  return http.put(url, data).then(res => {
    return res
  })
}
// 发送邮件状态
const macademicSend = new Restful(project, 'macademic/sended')

// 外编
const inviteMacademic = new Restful(project, 'invite/macademic')

// 获取外编列表
inviteMacademic.getList = function(data) {
  const url = project + 'invite/macademic/decision'
  return http.get(url, data).then(res => {
    return res
  })
}
inviteMacademic.count = function(data) {
  const url = project + 'invite/macademic/decision/num'
  return http.get(url, data).then(res => {
    return res
  })
}
// 提交决策
inviteMacademic.decision = function(type, data) {
  const url = project + 'invite/macademic/decision/' + type
  return http.post(url, data).then(res => {
    return res
  })
}
// 外编历史数据
inviteMacademic.history = function(id, type, data) {
  const url = project + 'invite/macademic/' + id + '/decision/' + type
  return http.get(url, data).then(res => {
    return res
  })
}

// 审稿报告
inviteMacademic.reviewer = function(id, type, data) {
  const url =
    project + 'invite/macademic/' + id + '/decision/' + type + '/reviewer'
  return http.get(url, data).then(res => {
    return res
  })
}

// 审稿报告（所有版本）
inviteMacademic.reviewerAll = function(id, data) {
  const url = project + 'invite/macademic/' + id + '/reviewer'
  return http.get(url, data).then(res => {
    return res
  })
}

// 登陆
inviteMacademic.login = function(data) {
  const url = project + 'invite/macademic/login'
  return http.get(url, data).then(res => {
    return res
  })
}

//
const inviteMacManuscript = new Restful(project, 'invite/macademic/manuscript')

inviteMacManuscript.getDecision = function(id, sign, data) {
  const url = project + `invite/macademic/manuscript/${id}/${sign}/decision`
  return http.get(url, data).then(res => {
    return res
  })
}
inviteMacManuscript.getReview = function(id, sign, data) {
  const url = project + `invite/macademic/manuscript/${id}/${sign}/reviewer`
  return http.get(url, data).then(res => {
    return res
  })
}

export default macademic
export { macademic, inviteMacademic, macademicSend, inviteMacManuscript }
